import { render } from "./PCReprocessed.vue?vue&type=template&id=3ea5a861&scoped=true"
import script from "./PCReprocessed.vue?vue&type=script&lang=js"
export * from "./PCReprocessed.vue?vue&type=script&lang=js"

import "./PCReprocessed.vue?vue&type=style&index=0&id=3ea5a861&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea5a861"]])

export default __exports__